import {computed, inject, ref} from "vue";
import {getTrainBreadcrumbs} from "@/common-scripts/train-helper";
import {useBookingStore} from "@/stores/booking";
import { useI18n } from "vue-i18n";
import {get as _get} from 'lodash-es';

export function usePriceGrid(travelSolution, train) {
	const i18n = useI18n();
	const { state: travelSolutionSelectionState } = inject('travelSolutionSelection');

	const mapOfferBestServiceId = ref({});
	const priceGrid = computed(() => {
		return _get(travelSolution, ['priceGrid', train.id]);
	});
	const bookingStore = useBookingStore();
	const selectedOfferId = computed(() => {
		return _get(travelSolutionSelectionState.selectedTrainGridOffers, [train.id, 'offerId']);
	});
	const selectedOffer = computed(() => {
		return _get(bookingStore.servicesMap, ['offers', selectedOfferId.value]);
	});

	function infoOffer (offer) {
		offer = offer.replace(' ', '%20');

		window.open(
			i18n.t('links.offer_info', 'https://www.trenitalia.com/it/html/trenitalia/Info_Tariffe_it_LeFrecce.html') + '#' + offer.toUpperCase(),
			'Info ' + offer,
			"height=450,width=600"
		);
		return ;
	}
	// TODO: SCOPRIRE SE LE DESCRIZIONI SONO PRESENTI NEL DB OPPURE CERCARE LINK/ALTRO PER AVERE LE INFO E LE IMMAGINI
	function infoService (service) {
		service = service.replace(' ', '%20');

		window.open(
			i18n.t('links.service_info', '???') + '#' + service.toUpperCase(),
			'Info ' + service,
			"height=450,width=600"
		);
		return;
	}

	const cartaIsRequired = computed(() => {
		if(!selectedOffer.value) return false;
		if(!selectedOffer.value.selection_traveller_parameters_map) return false;
		return Boolean(selectedOffer.value.selection_traveller_parameters_map.cartaFreccia);
	});
	
	return {
		infoOffer,
		infoService,
		// a train can have subSegments so can have multi trains
		trainsInfo: computed(() => {
			if(!train) return [];
			const trains = getTrainBreadcrumbs([train]);
			if(!trains) return [];
			return trains.map(train => {
				return {
					icon: train.icon,
					name: train.name,
					startStation: train.start.stationName,
					startDate: new Date(train.departure).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit',  hour12: false}),
					endStation: train.end.stationName,
					endDate: new Date(train.arrival).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false}) 
				};
			})
		}),
		priceGrid: priceGrid,
		columns: computed(() => {
			const columns = [];
			if(!priceGrid.value || !priceGrid.value.columns) return [];
			for (const colKey of priceGrid.value.columns) {
				const column = _get(bookingStore.servicesMap, ['catalog_services', colKey]);
				if(!column) continue;
				columns.push(column);
			}
			return columns;
		}),
		rows: computed(() => {
			const rows = [];
			if(!priceGrid.value || !priceGrid.value.rows) return [];
			for (const rowKey of priceGrid.value.rows) {
				const originalRow = _get(bookingStore.servicesMap, ['offers', rowKey]);
				if(!originalRow) continue;
				// if(!travelSolution.servicesMap.offers[rowKey]) continue;
				// rows.push(travelSolution.servicesMap.offers[rowKey]);

				const row = Object.assign({}, originalRow);
				// why, not make sens to me to calc best price here and set in bestPrice?
				row.bestPrice = {};
				let bestPrice = 99999999.99
				for (let servId in priceGrid.value.matrix[rowKey]) {
					if(!priceGrid.value.matrix[rowKey][servId]) continue;
					if (priceGrid.value.matrix[rowKey][servId].totalMoneyPrice.amount > bestPrice) continue;

					bestPrice = priceGrid.value.matrix[rowKey][servId].totalMoneyPrice.amount;
					row.bestPrice.price = bestPrice;
					row.bestPrice.currency = priceGrid.value.matrix[rowKey][servId].totalMoneyPrice.currency;
					row.bestPrice.serviceId = parseInt(servId);
					mapOfferBestServiceId.value[rowKey] = parseInt(servId);
				}

				rows.push(row);
			}
			return rows;
		}),
		mapOfferBestServiceId: mapOfferBestServiceId,
		selectedOfferId: selectedOfferId,
		selectedCatalogServiceId: computed(() => {
			return _get(travelSolutionSelectionState.selectedTrainGridOffers, [train.id, 'catalogServiceId']);
		}),
		selectedGridOffer: computed(() => {
			return _get(travelSolutionSelectionState.selectedTrainGridOffers, [train.id]);
		}),
		selectedOffer: selectedOffer,
		cartaIsRequired,
		showCartaFreccia: computed(() => {
			const hasCartaFreccia = bookingStore.isPostSale && bookingStore.passengers && Boolean(bookingStore.passengers.find(passenger => {
				return Boolean(_get(passenger, 'data.cartaFreccia'));
			}));
			return Boolean(cartaIsRequired.value || hasCartaFreccia);
		})
	}
}